// import * as Icons from '@/components/Icons'

import { Icon as Icons } from '@/utils/atom-shared'

import { getPropertyOfObject } from './get-property-of-object'

export function getIcon(name: string) {
  return getPropertyOfObject(Icons, name)
}
